module.exports = __webpack_public_path__ + "static/media/work_with_employers_icon_active.ef6ceb10.svg";